import React, { useContext, useState, useCallback, useMemo } from "react";
import "./UserMonitorToolbar.css";
import "../../../globalStyles/text.pc.css";
import BlueStarIcon from "../../../assets/ButtonIcons/favourite-icon-blue.svg";
import BlueStarIconActive from "../../../assets/ButtonIcons/favourite-icon-blue-active.svg";

import Search from "../../UiLib/Search/Search";
import { InputSwitch } from "primereact/inputswitch";

import MonitorFastFilter from "../FastFilters/MonitorFastFilter";
import { UserMonitorContext } from "../../../pages/UserMonitor/UserMonitor";
import FilterContainer from "../../Shared/Filter/FilterContainer";

interface IUserMonitorToolbarProps {
    showOnlyFavourite: boolean;
    showCompleted: boolean;
    setShowOnlyFavourite: (value: boolean) => void;
    setShowCompleted: (value: boolean) => void;
    taskNameSearch: string;
    setTaskNameSearch: (value: string) => void;
    onSearchSubmit: (value: string) => void;
}

const UserMonitorToolbar: React.FC<IUserMonitorToolbarProps> = ({
    showOnlyFavourite,
    showCompleted,
    setShowOnlyFavourite,
    setShowCompleted,
    taskNameSearch,
    setTaskNameSearch,
    onSearchSubmit,
}) => {
    const { resetFilter, selectedFilters, setSelectedFilters, filters } =
        useContext(UserMonitorContext);

    const [filterCounter, setFilterCounter] = useState<number>(0);

    const handleShowCompletedChange = useCallback(() => {
        setShowCompleted(!showCompleted);
    }, [showCompleted, setShowCompleted]);

    const handleToggleFavourite = useCallback(() => {
        setShowOnlyFavourite(!showOnlyFavourite);
    }, [showOnlyFavourite, setShowOnlyFavourite]);

    const showResetButton = useMemo(() => taskNameSearch.length > 0, [taskNameSearch]);
    const starIconSrc = useMemo(() => 
        showOnlyFavourite ? BlueStarIconActive : BlueStarIcon, 
    [showOnlyFavourite]);

    const inputSwitchClass = useMemo(() => 
        showCompleted ? "show-completed-input-switch" : "", 
    [showCompleted]);

    return (
        <div className="user-monitor-toolbar">
            <div className="user-monitor-toolbar-left-part">
                <MonitorFastFilter />
                <div className="user-monitor-toolbar-switch-panel">
                    <span className="user-monitor-toolbar-left-part-text">
                        Показать завершенные
                    </span>
                    <InputSwitch
                        className={inputSwitchClass}
                        checked={showCompleted}
                        onChange={handleShowCompletedChange}
                    />
                </div>
            </div>
            <div className="user-monitor-toolbar-right-part">
                <Search
                    value={taskNameSearch}
                    onSubmitFunc={onSearchSubmit}
                    changeSearchValue={setTaskNameSearch}
                />
                <div
                    className="user-monitor-toolbar-button"
                    onClick={handleToggleFavourite}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            handleToggleFavourite();
                        }
                    }}
                >
                    <img 
                        src={starIconSrc} 
                        alt="Только избранные" 
                    />
                </div>
                <FilterContainer
                    filterCounter={filterCounter}
                    setFilterCounter={setFilterCounter}
                    selectedOptions={selectedFilters}
                    setSelectedOptions={setSelectedFilters}
                    filterOptions={filters}
                    showResetButton={showResetButton}
                    onReset={resetFilter}
                />
            </div>
        </div>
    );
};

export default React.memo(UserMonitorToolbar);